export type MeetingType = 'VISIT' | 'FIRST_MEASUREMENT' | 'SECOND_MEASUREMENT' | 'OTHER' | 'CONTRACT' | 'RECEIVING' | 'WAITING_LIST'
 | 'NOTE' | 'SECOND_MEASUREMENT_AND_RECEIVING' | 'TAKING_MEASUREMENTS' | 'SECOND_VISIT' | 'CONSULTING_SERVICES';

export const meetingTypesArray: MeetingType[] = [
    'VISIT',
    'SECOND_VISIT',
    'CONTRACT',
    'TAKING_MEASUREMENTS',
    'FIRST_MEASUREMENT',
    'SECOND_MEASUREMENT',
    'SECOND_MEASUREMENT_AND_RECEIVING',
    'RECEIVING',
    'CONSULTING_SERVICES',
    'OTHER',
    'WAITING_LIST',
    'NOTE',
];
  

export function meetingTypeToTranslationKey(status: MeetingType): string {
  switch (status) {
    case 'VISIT' as MeetingType:
      return "calendar.meeting.status.visit";
    case 'SECOND_VISIT' as MeetingType:
        return "calendar.meeting.status.second_visit";
    case 'CONTRACT' as MeetingType:
        return "calendar.meeting.status.contract";
    case 'TAKING_MEASUREMENTS' as MeetingType:
        return "calendar.meeting.status.taking_measurements";
    case 'FIRST_MEASUREMENT' as MeetingType:
        return "calendar.meeting.status.first_measurement";
    case 'SECOND_MEASUREMENT' as MeetingType:
        return "calendar.meeting.status.second_measurement";
    case 'SECOND_MEASUREMENT_AND_RECEIVING' as MeetingType:
        return "calendar.meeting.status.second_measurement_and_receiving";
    case 'RECEIVING' as MeetingType:
        return "calendar.meeting.status.receiving";
    case 'CONSULTING_SERVICES' as MeetingType:
        return "calendar.meeting.status.consulting_services";
    case 'OTHER' as MeetingType:
        return "calendar.meeting.status.other";
    case 'WAITING_LIST' as MeetingType:
        return "calendar.meeting.status.waiting_list";
    case 'NOTE' as MeetingType:
        return "calendar.meeting.status.note";
    default:
      return "global.unknown";
  }
}